module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"start":"Start","design":"Design","blog":"Blog","settings":"Settings","careerPortal":"Portal"}}')
  delete Component.options._Ctor
}
